import React, { useState, useEffect } from "react";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useSnackbar } from "notistack";
import { businessTypeDropdown } from "../../../../../data/freezedData";
import { checkObjHasAllValue } from "../../../../components/ui_comps/ComissionContainer";
import { useDispatch } from "react-redux";
import { addClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import RowButton from "../../../../components/ui_comps/RowButton";
import { fontSize } from "@mui/system";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  STATUS_CODE_200,
  SUCCESS,
} from "../../../../../utility/constants/valueConstants";

function ResellerBankDetails({ onClickNext, onClickBack, reduxData }) {
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [nameAsPerBank, setNameAsPerBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginTop: 20,
  };

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      reduxData?.businessName &&
      reduxData?.businessType &&
      reduxData?.nameAsPerBank &&
      reduxData?.bankAccountNumber &&
      reduxData?.bankIfscCode
    ) {
      setBusinessName(reduxData?.businessName);
      setBusinessType(reduxData?.businessType);
      setNameAsPerBank(reduxData?.nameAsPerBank);
      setAccountNumber(reduxData?.bankAccountNumber);
      setIfscCode(reduxData?.bankIfscCode);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CustomInput
        value={businessName}
        onChange={(data) => setBusinessName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Business Name "
        type="input"
        inputStyles={{
          ...containerStyle,
          marginBottom: "20px",
        }}
        validator="nameWithSpace"
      />
      <CustomInput
        value={businessType}
        onChange={(data) => setBusinessType(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Last Name"
        validator="name"
        type="select"
        dropdownStyle={{
          ...inputStyle,
        }}
        inputStyles={{
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
          width: "100%",
        }}
        options={businessTypeDropdown}
      />

      <div>
        <CustomInput
          value={nameAsPerBank}
          onChange={(data) => setNameAsPerBank(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Name as per bank"
          type="input"
          inputStyles={{
            ...containerStyle,
            marginTop: 20,
          }}
          validator="nameWithSpace"
        />
        <CustomInput
          value={accountNumber}
          onChange={(data) => setAccountNumber(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank account number"
          validator="accountNumber"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
        <CustomInput
          value={ifscCode}
          onChange={(data) => setIfscCode(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank IFSC code"
          validator="ifscCode"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          if (accountNumber && accountNumber.length < 9) {
            enqueueSnackbar("Please enter valid account number", {
              variant: "error",
            });

            return;
          }
          if (ifscCode && ifscCode.length !== 11) {
            enqueueSnackbar("Please enter valid ifsc code", {
              variant: "error",
            });

            return;
          }

          if (
            checkObjHasAllValue({
              businessName,
              businessType,
              nameAsPerBank,
              accountNumber,
              ifscCode,
            })
          ) {
            onClickNext({
              businessName,
              businessType,
              nameAsPerBank,
              bankAccountNumber: accountNumber,
              bankIfscCode: ifscCode,
            });
          } else {
            enqueueSnackbar("Please fill all the fields", {
              variant: "error",
            });
          }
        }}
      />
    </div>
  );
}

export default ResellerBankDetails;
